module.exports = "<template>\n    <canvas ref=\"canvas\"></canvas>\n</template>\n";